import fetch from './fetch'
import { Base64 } from 'js-base64'
import { encryptKey } from '@/config/global'
import { aesEncrypt } from '@/utils/util'

class UsersApi {
	public getUserInfo() {
		return fetch({
			url: 'injury/user/getUserInfo',
		})
	}

	public modifiedPwd(form: any) {
		form.oldPwd = aesEncrypt(form.oldPwd, encryptKey)
		form.newPwd = aesEncrypt(form.newPwd, encryptKey)
		return fetch({
			url: 'injury/user/modifiedPwd',
			method: 'POST',
			data: form,
		})
	}

	public addUser(form: any) {
		return fetch({
			url: 'injury/user/add',
			method: 'POST',
			data: form,
		})
	}

	public getCompanies(companyId = '') {
		return fetch({
			url: 'injury/resource/company',
			params: {
				companyId,
			},
		})
	}

	public getRoles(form?: any) {
		return fetch({
			url: 'injury/resource/roles',
			params: form,
		})
	}

	public getUserList(form: object) {
		return fetch({
			url: 'injury/user/searchEmployeeList',
			method: 'post',
			data: form,
		})
	}

	public updateUser(form: object) {
		return fetch({
			url: 'injury/user/update',
			method: 'post',
			data: form,
		})
	}

	public changeAccountStatus(form: object) {
		return fetch({
			url: 'injury/user/changeAccountStatus',
			method: 'post',
			data: form,
		})
	}

	public resetPwd(userName: string) {
		return fetch({
			url: 'injury/user/resetPwd',
			params: {
				userName,
			},
		})
	}

	public sendByUserMobile() {
		return fetch({
			url: 'injury/user/sendByUserMobile',
		})
	}
	public countInfo() {
		return fetch({
			url: 'injury/resource/countInfo',
		})
	}
}

export default new UsersApi()
